import {exportImageCollection} from "./outputGeneration";
import {exportPartsList} from "./componentListExport";
import {closeSpinner, openSpinner, showErrorMessage} from "../../ui/ui";
import {t} from "../../i18n";

export function getProjectSummary(download = true, callback = null, errorCallback = null) {
    try {
        openSpinner(t("summary_preparing"));
        exportImageCollection(false, () => {
            exportPartsList(false).then(function() {
                $.ajax({
                    url: '/configurator/project-summary/' + templateId,
                    method: "GET",
                    headers: {
                        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                    },
                    async: true,
                    success: function (data) {
                        if (download) {
                            downloadFile('/configurator/open-pdf/' + templateId);
                        }
                        closeSpinner();
                        if (callback !== null) {
                            callback();
                        }
                    },
                    error: function (e) {
                        console.error("error in pdf",e);
                        closeSpinner();
                        showErrorMessage(t("summary_error"));
                        if (errorCallback !== null) {
                            errorCallback();
                        }
                    },
                    always: function () {

                    }
                });
            });

        });
    } catch (e) {
        console.error("error in pdf generation",e);
        closeSpinner();
        showErrorMessage(t("summary_error"));
        if (errorCallback !== null) {
            errorCallback();
        }
    }
}

function downloadFile(url) {
  const a = document.createElement('a')
  a.href = url
  a.download = url.split('/').pop()
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
